import {createReducer, isAnyOf} from '@reduxjs/toolkit'
import {AnyAction} from 'redux'
import {
  PLACE_ORDER_OLD,
  UPDATE_ORDER_OLD,
  expressCheckout,
  getOrder,
  getOrderTicketsDownloadUrl,
  placeOrder,
  pollOrder,
  updateOrder,
} from '../actions/placed-order'
import {RESERVE_TICKETS_OLD, makeReservation} from '../actions/reservation'
import {PlacedOrderState} from '../types/state'

const defaultState: PlacedOrderState = {
  order: undefined,
  loadingTicketsUrl: true,
  orderPageUrl: null,
  chargeToken: null,
  clientStatus: null,
  pollEnded: false,
}

export const placedOrder = createReducer(defaultState, builder => {
  builder
    .addCase(PLACE_ORDER_OLD.SUCCESS, (state, action: AnyAction) => {
      return {
        ...state,
        ...action.payload,
      }
    })
    .addCase(placeOrder.fulfilled, (state, action) => {
      return {
        ...state,
        ...action.payload,
      }
    })
    .addCase(UPDATE_ORDER_OLD.SUCCESS, (state, action: AnyAction) => {
      return {
        ...state,
        ...action.payload,
      }
    })
    .addCase(pollOrder.fulfilled, (state, action) => {
      state.order = action.payload
      state.pollEnded = true
    })
    .addCase(pollOrder.rejected, state => {
      state.pollEnded = true
    })
    .addCase(RESERVE_TICKETS_OLD.REQUEST, () => {
      return defaultState
    })
    .addCase(makeReservation.pending, () => {
      return defaultState
    })
    .addCase(getOrderTicketsDownloadUrl.pending, state => {
      state.loadingTicketsUrl = true
    })
    .addCase(getOrderTicketsDownloadUrl.fulfilled, (state, action) => {
      if (!action.payload) {
        return defaultState
      }
      const {loadingTicketsUrl, downloadTicketsUrl} = action.payload
      state.loadingTicketsUrl = loadingTicketsUrl
      state.downloadTicketsUrl = downloadTicketsUrl
    })
    .addCase(getOrderTicketsDownloadUrl.rejected, () => {
      return defaultState
    })
    .addCase(expressCheckout.fulfilled, (state, action) => {
      state.clientStatus = action.payload.clientStatus
    })
    .addMatcher(isAnyOf(updateOrder.fulfilled, getOrder.fulfilled), (state, action) => {
      return {
        ...state,
        ...action.payload,
      }
    })
})
